/**
 * assembly/input/submitMode.ts —— **繁忙态投递模式决议**（★20261011 大王决策「插话/排队旧树未完整实现，照抄 dsh」）
 *
 * 语义来源（逐字）：dsh 224 实跑件 `lib/client.js`
 *   `function resolveSubmitMode(preferred, running, gesture, steeringAvailable) {
 *      if (!running || !steeringAvailable) return "queue";
 *      if (gesture === "accelerated") return "steer";
 *      return preferred;  // 偏好：Queue / Steer（设置面「繁忙时的发送行为」持久化）
 *    }`
 *   中文串：`settings.enter.title`＝「繁忙时的发送行为」；按钮随偏好命名 `input.send.queue`／`input.send.steer`；
 *   占位符 `placeholder.steerQueue`＝「Cmd/Ctrl+Enter 插话发送全部排队消息」。
 *
 * 本件只做**纯决议**（无 IO、无状态）：把 dsh 的四参决议原样搬进来，供 Composer 与单测共用。
 *   `running`           运行中（旧树/新树同源：`props.running`）
 *   `steeringAvailable` 插话通道可用（缺省真；宿主未接插话面 ⇒ 假 ⇒ 一律排队，**不假发**）
 *   `gesture`           `"accelerated"`＝Cmd/Ctrl+Enter（加速手势）
 *   `preferred`         持久化偏好：`"queue"`（默认）／`"steer"`
 */

export type SubmitMode = "queue" | "steer";
export type BusyEnterPreference = SubmitMode;

export interface ResolveSubmitModeInput {
  preferred: BusyEnterPreference;
  running: boolean;
  gesture: "accelerated" | "plain";
  steeringAvailable: boolean;
}

/** dsh `resolveSubmitMode` 逐字译（含短路序：不可插话 ⇒ 排队优先于手势） */
export function resolveSubmitMode(i: ResolveSubmitModeInput): SubmitMode {
  if (!i.running || !i.steeringAvailable) return "queue";
  if (i.gesture === "accelerated") return "steer";
  return i.preferred;
}

/** 是否加速手势（dsh：Cmd/Ctrl+Enter；与「Enter 模式」偏好同源读取，见 Composer `onKeydown`） */
export function isAccelerated(ev: { metaKey?: boolean; ctrlKey?: boolean }): boolean {
  return ev.metaKey === true || ev.ctrlKey === true;
}

/** 主按钮文案（随模式；dsh 同序：排队⇒「排队发送」，插话⇒「插话发送」；空闲⇒「发送」） */
export function submitButtonLabel(mode: SubmitMode, running: boolean): string {
  if (!running) return "发送";
  return mode === "steer" ? "插话发送" : "排队发送";
}
